import React, { useContext, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import { Zoom } from "react-reveal";
import { GetCategoryActivities } from "../../API/activities";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import { ThemeContext } from "../../context/ThemeContext";
import { useBusinessNameContext } from "../../context/BusinessName";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";

function Activities() {
  const { businessName, setBusinessName } = useBusinessNameContext();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const { theme } = useContext(ThemeContext);
  const lang = localStorage.getItem("lang");

  let activitiesData;
  let bgColor;
  let color;
  let text;
  let activities;

  const { data, isLoading, error } = GetCategoryActivities(
    params.room_uuid,
    params.company_uuid,
    params.category_id,
    lang
  );

  if (!isLoading) {
    if (error) {
      if (error?.response?.status === 404) {
        navigate(`/not-found`);
      }
    } else {
      if (data?.data?.status === false) {
        navigate(`/${params.room_uuid}/qr-scan`);
      } else {
        activitiesData = data?.data;
        activities = activitiesData?.activities;
        color = activitiesData?.color;
        bgColor = activitiesData?.header_color;
        text = activitiesData?.header_title;

        console.log("ShowActivities", activitiesData);
      }
    }
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  return (
    <div
      className={`
  ${
    theme && businessName === "Beno Jumeirah Sport Activity"
      ? "food pb-1 activities-custom-styles"
      : ""
  }
  ${theme ? "food pb-1" : ""}
 ${lang === "AR" && "arabic"}`}
    >
      {theme ? <Title title={text} /> : <HeaderInner headerName={text} />}
      <main className="home-main bg-white pt-3">
        <div className={theme ? "box_food" : ""}>
          {isLoading ? (
            <CustomBusinessServiceLoader
              businessName={businessName}
              loader={"spa"}
            />
          ) : activities ? (
            activities.map((activity, idx) => {
              return theme ? (
                <div key={idx}>
                  <Link
                    to={`/${params.room_uuid}/activities/category-activities/${
                      params.company_uuid
                    }/${activity.id.toString()}/activity`}
                    state={{ activity }}
                  >
                    <img src={activity?.image} alt="" className="booking_img" />
                    <img src={Overllay} alt="" className="overlay" />
                    <div className="text_food">
                      <h5 className="">{activity.name}</h5>
                    </div>
                  </Link>
                </div>
              ) : (
                <div id={activity.name} key={idx}>
                  <Zoom>
                    <div
                      className="con-img-container v3"
                      onClick={() =>
                        navigate(
                          `/${
                            params.room_uuid
                          }/activities/category-activities/${
                            params.company_uuid
                          }/${activity.id.toString()}/activity`,
                          { state: { activity } }
                        )
                      }
                    >
                      <div className="con-img">
                        <img src={activity.image} alt="" />
                        <p></p>
                      </div>
                    </div>
                    <div className="con-text-container">
                      <p>{activity.name}</p>
                      <hr className="mb-0 dark" />
                    </div>
                  </Zoom>
                </div>
              );
            })
          ) : null}
        </div>
      </main>
      {theme && businessName !== "Beno Jumeirah Sport Activity" && (
        <NewFooter />
      )}
    </div>
  );
}

export default Activities;
